import React, { useState } from "react";
import "./ForgotPassword.scss";
import Logo from "../../assets/Logo.png";
import Logo_Banner from "../../assets/logo_banner.png";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { webEndPoint } from "../../constant/constant";
import { makeRequest } from "../../services/api";
import Loader from "../../components/Loader/Loader";
import { getItem, setItem } from "../../services/utilities";
import { Button } from "antd";
import AlertModal from "./../../components/Modals/AlertModal";
function VerifyCode() {
  let navigate = useNavigate();
  let userOtpData = getItem("userOtpDetail");
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const onSubmit = (data) => {
    setItem("userOtpNol", data.code);
    sentOtp({
      verification_type: "forgot_password",
      otp_id: userOtpData?.data?.otp_id || "",
      user_otp: data.code,
    });
  };
  const sentOtp = async (data) => {
    try {
      setLoading(true);
      let url = webEndPoint + "auth/verify-otp";
      const response = await makeRequest("post", url, data);
      if (response) {
        setLoading(false);
        navigate("/create_new_password");
      }
    } catch (err) {
      setLoading(false);
      setErrorMsg(JSON.stringify(err?.alert) || 'Invalid Verification Code' );
      setOpenModal(true);
    }
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Loader loading={loading} />
      <div className="grid">
        <div className="order__left centered">
          <div className="form">
            <img
              className="astro_logo centered"
              src={Logo}
              alt="astrocure_logo"
            />
            <p className="verify-header-text">
              One final step! We need to verify your email
            </p>
            <p className="verify-description-text">
              Please check your inbox for verification code sent to
              abhi@gmail.co.in
            </p>
            <input
              {...register("code", { required: true })}
              type="text"
              id="code"
              name="code"
              placeholder="Enter the 6-digit code here"
              className="forgot_input_style"
              autocomplete="off"
            />
            {errors.code && (
              <p className="alert_msg">Verification Code is required.</p>
            )}
            <p className="seconds_text">60 sec</p>
            <button type="submit" class="verify_code verify_text">
              Verify Code
            </button>
            <p className="seconds_text">
              Can’t find it ? Please check your spam folder
            </p>

            <button type="submit" class="resend__button forgot__text">
              Resend Code
            </button>
            <div class="signup">
              <label className="remember_me">Copyright © 2024</label>
              <a href="#" class="forgot__password">
                <strong>Astrovidhi Private Limited</strong>{" "}
              </a>{" "}
              <label className="remember_me"> All rights reserved</label>
            </div>
          </div>
        </div>
        <div className="order__right no__overflow banner">
          <img className="banner__image" src={Logo_Banner} alt="banner" />
        </div>
      </div>
      <AlertModal open={openModal} setOpen={setOpenModal} errorMsg={errorMsg} />
    </form>
  );
}

export default VerifyCode;
